import {
  BankDetailsPayload,
  BankDetailsResponse,
} from "@/utils/types/NPS/Stepper/BankDetils";
import { put } from "@/services/axiosUitils";

const baseUrl = "/nps/registration";

class BankDetailsService {
  createBankDetails = async (
    ackId: string,
    payload: BankDetailsPayload,
    nextStep?: string
  ): Promise<BankDetailsResponse> => {
    const response = await put<BankDetailsResponse>(
      `${baseUrl}/${ackId}/${nextStep}/`,
      payload,
      {}
    );
    return response;
  };
}

const instance = new BankDetailsService();
export default instance;
